module.exports = __webpack_public_path__ + "static/media/W1_NORM.36e28bc8.png";